module.exports = __webpack_public_path__ + "static/img/Guanyu.d997071.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Guanyu.jpg
// module id = PQQO
// module chunks = 1